export enum SakskategoriType {
    support = 'support',
    property = 'property',
}
